module.exports = __webpack_public_path__ + "media/images/wealthbar/2fa/sms-icon-inactive-dafeadc543967bd54a67a64faba664b5.svg";